<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Destination
      </h1>
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ name: 'dashboard' }">
            <i class="fa fa-dashboard"></i> Home
          </router-link>
        </li>
        <li>
          <router-link :to="{name: 'destination-index'}">
            Destinations
          </router-link>
        </li>
        <li class="active">
          <span v-if="isCreate">Create</span>
          <span v-if="isEdit">Edit</span>
          <span v-if="isView">View</span>
        </li>
      </ol>
    </section>

    <section class="content">
      <div class="row">
        <div class="col-md-12">

          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">{{ title }}</h3>
            </div>

            <form class="form-horizontal" @submit.prevent="submit">
              <div class="box-body" style="overflow: unset;">
                <div v-if="error" class="alert alert-danger">
                  <a class="close" @click="error = false">&times;</a>
                  {{ error }}
                </div>

                <div class="form-group">
                  <label for="type" class="col-sm-2 control-label">
                    Region <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <select
                      :disabled="isView"
                      class="form-control"
                      id="type"
                      v-model="form.type">
                      <option value="domestic">Domestic</option>
                      <option value="international">International</option>
                    </select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="name" class="col-sm-2 control-label">
                    Name <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input type="text"
                      class="form-control"
                      id="name"
                      :disabled="isView"
                      :style="checkError.name ? 'border-color:#FF3333' : ''"
                      placeholder="Name"
                      v-model="form.name">
                      <p v-if="checkError.name" style="color:#FF3333; margin:0">
                        {{ checkError.name }}
                      </p>
                  </div>
                </div>

                <div class="form-group">
                  <label for="name_en" class="col-sm-2 control-label">
                    Name En <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input type="text"
                      class="form-control"
                      id="name_en"
                      :disabled="isView"
                      placeholder="Name"
                      :style="checkError.name_en ? 'border-color:#FF3333' : ''"
                      v-model="form.name_en">
                      <p v-if="checkError.name_en" style="color:#FF3333; margin:0">
                        {{ checkError.name_en }}
                      </p>
                  </div>
                </div>

                <div class="form-group">
                  <label for="slug" class="col-sm-2 control-label">
                    Slug
                  </label>

                  <div class="col-sm-10">
                    <input type="text"
                      class="form-control"
                      id="slug"
                      :disabled="isView"
                      placeholder="Slug"
                      v-model="form.slug">
                  </div>
                </div>

                <div class="form-group">
                  <label for="parent" class="col-sm-2 control-label">
                    Image <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <div class="row">
                      <div class="col-md-2">
                        <img v-if="form.image.url"
                          class="img-thumbnail img-responsive"
                          alt="Destination Image"
                          :src="parseImage(form.image.url, '_thumb')">

                        <img v-else
                          class="img-thumbnail img-responsive"
                          src="/static/img/img_placeholder.png"
                          alt="No image">
                      </div>

                      <div class="col-md-10">
                        <button :disabled="isView" class="btn btn-sm btn-secondary"
                          @click.prevent="showModal('gallery')">
                          Select Image
                        </button>
                      </div>
                    </div>
                    <p v-if="checkError.image" style="color:#FF3333; margin:0">
                      {{ checkError.image }}
                    </p>
                  </div>
                </div>

                <div class="form-group">
                  <label for="description" class="col-sm-2 control-label">
                    Description
                  </label>

                  <div class="col-sm-10">
                    <input type="text"
                      class="form-control"
                      id="description"
                      :disabled="isView"
                      placeholder="Description"
                      maxlength="300"
                      v-model="form.description">
                  </div>
                </div>

                <div class="form-group">
                  <label for="description_en" class="col-sm-2 control-label">
                    Description En
                  </label>

                  <div class="col-sm-10">
                    <input type="text"
                      class="form-control"
                      id="description_en"
                      :disabled="isView"
                      placeholder="Description En"
                      maxlength="300"
                      v-model="form.description_en">
                  </div>
                </div>

                <div class="form-group">
                  <label for="description_en" class="col-sm-2 control-label">
                    Destination Type <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <select 
                      v-model="form.destinationType" 
                      :disabled="isView" 
                      class="form-control" 
                      :style="checkError.destinationType ? 'border-color:#FF3333' : ''"
                      id="vendor" 
                      placeholder="Select Destination Type">
                      <option v-for="(data, index) in destinationType" :key="`${index}-${data.value}`" :value="data.value">
                      {{ data.label }}
                      </option>
                    </select>
                    <p v-if="checkError.destinationType" style="color:#FF3333; margin:0">
                        {{ checkError.destinationType }}
                      </p>
                  </div>
                </div>

                <div class="form-group">
                  <label for="parent" class="col-sm-2 control-label">
                    Parent <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <treeselect
                      placeholder="Select parent"
                      v-model="form.parent"
                      value-format="object"
                      :multiple="false"
                      :disabled="isView || form.destinationType === null"
                      :options="destinations"
                      :load-options="loadOptions"
                      :style="checkError.parent ? 'border-color:#FF3333' : ''"
                      :auto-load-root-options="false">
                    </treeselect>
                    <p v-if="checkError.parent" style="color:#FF3333; margin:0">
                        {{ checkError.parent }}
                      </p>
                  </div>
                </div>

                <transition name="slideDown">
                  <modal title="Select Destination Image"
                    v-if="show.gallery">
                    <FileGallery
                      type="destination"
                      @update-images="setImage"
                      :selected="form.image" />
                  </modal>
                </transition>
              </div>

              <div class="box-footer">
                <button type="submit" class="btn btn-info pull-right" v-if="isCreate" @click="checkForm">Create</button>
                <button type="submit" class="btn btn-info pull-right" v-if="isEdit" @click="checkForm">Update</button>
                <div v-if="error" class="alert alert-danger">
                  <a class="close"
                    @click="error = false">
                    &times;
                  </a>
                  {{ error }}
                </div>
                <a class="btn btn-default" @click.prevent="cancel">Cancel</a>
              </div>

            </form>
          </div>
        </div>
      </div>
      <transition name="modal">
        <div class="modal-mask" @click.self="setDefaultModal" v-if="modalVisible">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" @click.prevent="setDefaultModal">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title"> {{ isCreateModal ? 'Add New City' : 'Edit City'}}</h4>
                </div>
                <div class="modal-body">
                  <form class="form-horizontal" @submit.prevent="submit('modal')">
                    <div class="box-body" style="overflow: unset;">
                      <div v-if="error" class="alert alert-danger">
                        <a class="close" @click="error = false">&times;</a>
                        {{ error }}
                      </div>

                      <div class="form-group">
                        <label for="type" class="col-sm-2 control-label">
                          Region <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <select
                            disabled
                            class="form-control"
                            id="type"
                            v-model="formModal.type">
                            <option value="domestic">Domestic</option>
                            <option value="international">International</option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="name" class="col-sm-2 control-label">
                          Name <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <input type="text"
                            class="form-control"
                            id="name"
                            :disabled="isView"
                            placeholder="Name"
                            :style="checkErrorModal.name ? 'border-color:#FF3333' : ''"
                            v-model="formModal.name">
                            <p v-if="checkErrorModal.name" style="color:#FF3333; margin:0">
                              {{ checkErrorModal.name }}
                            </p>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="name_en" class="col-sm-2 control-label">
                          Name En <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <input type="text"
                            class="form-control"
                            id="name_en"
                            :disabled="isView"
                            placeholder="Name"
                            :style="checkErrorModal.name_en ? 'border-color:#FF3333' : ''"
                            v-model="formModal.name_en">
                              <p v-if="checkErrorModal.name_en" style="color:#FF3333; margin:0">
                                {{ checkErrorModal.name_en }}
                              </p>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="slug" class="col-sm-2 control-label">
                          Slug
                        </label>

                        <div class="col-sm-10">
                          <input type="text"
                            class="form-control"
                            id="slug"
                            :disabled="isView"
                            placeholder="Slug"
                            v-model="formModal.slug">
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="parent" class="col-sm-2 control-label">
                          Image <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-md-2">
                              <img v-if="formModal.image.url"
                                class="img-thumbnail img-responsive"
                                alt="Destination Image"
                                :src="parseImage(formModal.image.url, '_thumb')">

                              <img v-else
                                class="img-thumbnail img-responsive"
                                src="/static/img/img_placeholder.png"
                                alt="No image">
                            </div>

                            <div class="col-md-10">
                              <button :disabled="isView" class="btn btn-sm btn-secondary"
                                @click.prevent="showModal('gallery')">
                                Select Image
                              </button>
                            </div>
                          </div>
                          <p v-if="checkErrorModal.image" style="color:#FF3333; margin:0">
                            {{ checkErrorModal.image }}
                          </p>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="description" class="col-sm-2 control-label">
                          Description
                        </label>

                        <div class="col-sm-10">
                          <input type="text"
                            class="form-control"
                            id="description"
                            :disabled="isView"
                            placeholder="Description"
                            v-model="formModal.description">
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="description_en" class="col-sm-2 control-label">
                          Description En
                        </label>

                        <div class="col-sm-10">
                          <input type="text"
                            class="form-control"
                            id="description_en"
                            :disabled="isView"
                            placeholder="Description En"
                            v-model="formModal.description_en">
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="description_en" class="col-sm-2 control-label">
                          Destination Type <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <select 
                          v-model="formModal.destinationType" 
                          disabled class="form-control" 
                          id="vendor"
                          :style="checkError.destinationType ? 'border-color:#FF3333' : ''"
                          placeholder="Select Destination Type">
                            <option v-for="(data, index) in destinationType" :key="`${index}-${data.value}`" :value="data.value">
                            {{ data.label }}
                            </option>
                          </select>
                          <p v-if="checkErrorModal.destinationType" style="color:#FF3333; margin:0">
                            {{ checkErrorModal.destinationType }}
                          </p>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="parent" class="col-sm-2 control-label">
                          Parent <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <treeselect
                            disabled
                            placeholder="Select parent"
                            v-model="formModal.parent"
                            value-format="object"
                            :multiple="false"
                            :options="destinations"
                            :load-options="loadOptions"
                            :style="checkErrorModal.parent ? 'border-color:#FF3333' : ''"
                            :auto-load-root-options="false">
                          </treeselect>
                          <p v-if="checkErrorModal.parent" style="color:#FF3333; margin:0">
                            {{ checkErrorModal.parent }}
                          </p>
                        </div>
                      </div>

                      <transition name="slideDown">
                        <modal title="Select Destination Image"
                          v-if="show.gallery">
                          <FileGallery
                            type="destination"
                            @update-images="setImageModal"
                            :selected="formModal.image" />
                        </modal>
                      </transition>
                    </div>

                    <div class="box-footer">
                      <button type="submit" class="btn btn-info pull-right" v-if="isCreateModal" @click="checkForm('modal')">Create</button>
                      <button type="submit" class="btn btn-info pull-right" v-if="isEditModal" @click="checkForm('modal')">Update</button>
                      <div v-if="error" class="alert alert-danger">
                        <a class="close"
                          @click="error = false">
                          &times;
                        </a>
                        {{ error }}
                      </div>
                      <a class="btn btn-default" @click.prevent="setDefaultModal">Cancel</a>
                    </div>

                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <section v-if="((destinationData.region_type === 'province' && destinationData.type === 'domestic') || (destinationData.region_type === 'country' && destinationData.type === 'international'))" class="box">
        <div v-if="!isView" class="box-header">
          <a class="btn btn-success pull-right"
            @click="addModal(destinationData)">
            Add City
          </a>
        </div>
        <div class="box-body">
          <table id="table" class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>City</th>
                <th>Image</th>
                <th>Slug</th>
                <th v-if="!isView">Action(s)</th>
              </tr>
            </thead>
            <tbody v-if="destinationData.child">
              <template v-for="item in destinationData.child">
                <tr :key="item.id">
                  <td>
                    {{ item.name }}
                  </td>
                  <td class="text-center">
                      <img
                        v-if="item.image_url && item.image_url != ''"
                        :src="parseImage(item.image_url, '_thumb')"
                        style="width: 85px" />
                    </td>
                  <td>
                    {{ item.slug }}
                  </td>
                  <td v-if="!isView">
                      <a class="btn btn-primary btn-xs" @click.prevent="editModal(item, destinationData.name)">Edit</a>
                      <a class="btn btn-danger btn-xs" @click.prevent="remove(item)">Delete</a>
                      <div v-if="error" class="alert alert-danger">
                        <a class="close"
                          @click="error = false">
                          &times;
                        </a>
                        {{ error }}
                      </div>
                    </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </section>
    </section>

  </div>
</template>

<script>
import { Treeselect, LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect';
import bus from '@/utils/bus';
import Common from '@/mixins/Common';
import Modal from '@/components/modules/common/Modal';
import FileGallery from '@/components/modules/common/FileGallery';

require('@riophae/vue-treeselect/dist/vue-treeselect.min.css');

export default {
  name: 'DestinationForm',

  mixins: [Common],

  data() {
    return {
      title: 'Add New Destination',
      modalVisible: false,
      checkError: { 
        name: null,
        name_en: null,
        image: null,
        destinationType: null,
        parent: null,
         },
      checkErrorModal: { 
        name: null,
        name_en: null,
        image: null,
        destinationType: null,
        parent: null,
      },
      form: {
        id: null,
        type: 'domestic',
        name: null,
        name_en: null,
        description: null,
        description_en: null,
        slug: null,
        destinationType: null,
        parent: null,
        image: {
          id: null,
          url: null,
        },
      },

      isCreateModal: false,
      isEditModal: false,

      formModal: {
        id: null,
        type: 'domestic',
        name: null,
        name_en: null,
        description: null,
        description_en: null,
        slug: null,
        destinationType: null,
        parent: null,
        image: {
          id: null,
          url: null,
        },
      },

      show: {
        gallery: false,
      },

      destinationData: {},

      error: null,

      destinations: null,
      destinationType: [
        { label: 'City', value: 'city' },
        { label: 'Province', value: 'province' },
        { label: 'Country', value: 'country' },
      ],
      flatDestinations: [],
    };
  },

  props: {
    isCreate: {
      type: Boolean,
      required: false,
    },
    isEdit: {
      type: Boolean,
      required: false,
    },
    isView: {
      type: Boolean,
      required: false,
    },
  },

  components: {
    Treeselect,
    FileGallery,
    Modal,
  },
  watch: {
    'form.type': function () {
      this.$router.push(`?types=${this.form.type}`);
    },
    'form.destinationType': async function () {
      this.form.parent = null; 
      const destinations = await this.getDestinationByType();
      this.destinations = await this.generate(destinations);
      if (this.form.destinationType === 'country') {
        this.form.parent = this.destinations[0];
      }
    },
  },
  methods: {
    fetch() {
      return new Promise((resolve) => {
        this.axios.get('destinations', { params: { perpage: 200, type: this.$route.query.types } })
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            console.log('Fetch error', error);
            if (error) {
              this.errors = error.response.data.errors;
            }
          });
        });
    },

    getDestinationByType() {
      return new Promise((resolve) => {
        this.axios.get(`destinations/parent?type=${this.form.type}&region_type=${this.form.destinationType}`)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          console.log('Fetch error', error);
        });
      });
    },

    get() {
      return new Promise((resolve) => {
        this.axios.get(`/destinations/${this.$route.params.id}`)
          .then((response) => {
            const { data } = response.data;
            
            this.destinationData = data || [];
            this.form.id = data.id || null;
            this.form.type = data.type || 'domestic';
            this.form.name = data.name || '';
            this.form.name_en = data.name_en || '';
            this.form.description = data.description || '';
            this.form.description_en = data.description_en || '';
            this.form.slug = data.slug || '';
            this.form.image.id = data.image_id || '';
            this.form.destinationType = data.region_type || null;
            this.form.image.url = data.image_url || '';

            if (data.parent_id) {
              this.set(data.parent_id);
            }

            resolve();
          })
          .catch((error) => {
            if (error.response) {
              this.errors = error.response.data.errors;
            }
          });
      });
    },

    flat() {
      const result = [];

      this.destinations.forEach((local) => {
        result.push({
          id: local.id,
          label: local.label,
          level: 1,
        });

        if (local.children) {
          local.children.forEach((parent) => {
            result.push({
              id: parent.id,
              label: parent.label,
              level: 2,
            });

            if (parent.children) {
              parent.children.forEach((child) => {
                result.push({
                  id: child.id,
                  label: child.label,
                  level: 3,
                });

                if (child.children) {
                  child.children.forEach((grandchild) => {
                    result.push({
                      id: grandchild.id,
                      label: grandchild.label,
                      level: 4,
                    });
                  });
                }
              });
            }
          });
        }
      });

      return result;
    },

    async set(parent) {
      this.flatDestinations = await this.flat();

      this.flatDestinations.forEach((item) => {
        if (parent === item.id) {
          this.form.parent = item;
        }
      });
    },

    generate(data) {
      if (!data) return [];

      return data.map((local) => {
        if (local.child) {
          return {
            id: local.id,
            label: local.name,
            level: 1,
            isDefaultExpanded: true,
            children: local.child.map((parent) => {
              if (parent.child) {
                return {
                  id: parent.id,
                  label: parent.name,
                  level: 2,
                  children: parent.child.map((parent2) => {
                    if (parent2.child) {
                      return {
                        id: parent2.id,
                        label: parent2.name,
                        level: 3,
                        children: parent2.child.map(child => ({
                          id: child.id,
                          label: child.name,
                          level: 4,
                        })),
                      };
                    }

                    return {
                      id: parent2.id,
                      label: parent2.name,
                      level: 3,
                    };
                  }),
                };
              }

              return {
                id: parent.id,
                label: parent.name,
                level: 2,
              };
            }),
          };
        }

        return {
          id: local.id,
          label: local.name,
          level: 1,
        };
      });
    },

    async init() {
      if (!this.isCreate) {
        const destinations = await this.getDestinationByType();
        this.destinations = await this.generate(destinations);
        await this.get();
      }
    },

    async loadOptions({ action }) {
      if (action === LOAD_ROOT_OPTIONS) {
        const destinations = await this.getDestinationByType();
        this.destinations = await this.generate(destinations);
      }
    },

    setValue(value) {
      this.form.parent = value;
    },

    setImage(payload) {
      this.form.image = payload.images;
    },
    setImageModal(payload) {
      this.formModal.image = payload.images;
    },

    showModal(modal) {
      this.$store.commit('SET_MODAL', modal);
      this.show[modal] = true;
      document.body.classList.add('locked');
    },

    popUpCall(type) {
      if (type === 'succeed') {
        this.$swal(
          'Succeed',
          'Create new destination succeed.',
          'success',
          2000,
        );
      }
      if (type === 'edited') {
        this.$swal(
          'Succeed',
          'Edit destination succeed.',
          'success',
          1000,
        );
      }
      if (type === 'error') {
        this.$swal({
          title: 'Failed',
          text: 'Destination Name already used.',
          type: 'error',
          timer: 8000,
        });
      }
    },

    addModal(value) {
      this.isCreateModal = true;
      this.isEditModal = false;
      this.modalVisible = true;
      this.formModal.type = value.type || 'domestic';
      this.formModal.destinationType = 'city' || null;
      this.formModal.parent = {
        id: value.id,
        label: value.name,
      };
    },
    add() {
      this.$router.push({
        name: 'destination-create',
      });
    },
    setDefaultModal() {
      if (this.modalVisible) {
        this.modalVisible = false;
      } else {
        this.modalVisible = true;
      }
      this.formModal.id = null;
      this.formModal.type = 'domestic';
      this.formModal.name = '';
      this.formModal.name_en = '';
      this.formModal.description = '';
      this.formModal.description_en = '';
      this.formModal.slug = '';
      this.formModal.image.id = null;
      this.formModal.destinationType = '';
      this.formModal.image.url = '';
      this.formModal.parent = {
          id: null,
          label: null,
        };
    },
    editModal(value, parent) {
      this.isEditModal = true;
      this.isCreateModal = false;
      this.modalVisible = true;
      this.formModal.id = value.id || null;
      this.formModal.type = value.type || 'domestic';
      this.formModal.name = value.name || '';
      this.formModal.name_en = value.name_en || '';
      this.formModal.description = value.description || '';
      this.formModal.description_en = value.description_en || '';
      this.formModal.slug = value.slug || '';
      this.formModal.image.id = value.image_id || '';
      this.formModal.destinationType = value.region_type || 'city';
      this.formModal.image.url = value.image_url || '';
      this.formModal.parent = {
          id: value.parent_id,
          label: parent,
        };
    },

    edit(id) {
      this.$router.push({
        name: 'destination-edit',
        params: {
          id,
        },
      });
    },

    delete(destination) {
      this.axios.delete(`/destinations/${destination.id}`)
        .then(() => {
          this.get();

          this.$swal(
            'Deleted!',
            `${destination.name} has been deleted.`,
            'success',
          );
        })
        .catch((error) => {
          if (error.response) {
            this.$swal({
              title: 'Failed',
              text: `Oppss! You can't delete "${destination.name}" because this destination still used by the product`,
              type: 'error',
              timer: 8000,
            });
          }
        });
    },

    remove(destination) {
      this.$swal({
        title: 'Deleting Destination',
        text: `Are you sure you want to delete ${destination.name}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      }).then((result) => {
        if (result.value) {
          this.delete(destination);
        } else {
          this.$swal(
            'Cancelled',
            null,
            'info',
          );
        }

        if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
          this.$swal(
            'Cancelled',
            null,
            'info',
          );
        }
      });
    },
    checkForm(type) {
      if (type === 'modal') {
        if (!this.formModal.name) {
        this.checkErrorModal.name = 'Please Input Name';
        } else {
          this.checkErrorModal.name = null;
        } 
        if (!this.formModal.name_en) {
          this.checkErrorModal.name_en = 'Please Input Name En';
        } else {
          this.checkErrorModal.name_en = null;
        }
        if (!this.formModal.image.id || !this.formModal.image.url) {
          this.checkErrorModal.image = 'Please Add image';
        } else {
          this.checkErrorModal.image = null;
        }
        if (!this.formModal.destinationType) {
          this.checkErrorModal.destinationType = 'Please Select destinationType';
        } else {
          this.checkErrorModal.destinationType = null;
        }
        if (!this.formModal.parent) {
          this.checkErrorModal.parent = 'Please Select parent';
        } else {
          this.checkErrorModal.parent = null;
        }
      } else {
        if (!this.form.name) {
          this.checkError.name = 'Please Input Name';
        } else {
          this.checkError.name = null;
        } 
        if (!this.form.name_en) {
          this.checkError.name_en = 'Please Input Name En';
        } else {
          this.checkError.name_en = null;
        }
        if (!this.form.image.id || !this.form.image.url) {
          this.checkError.image = 'Please Add image';
        } else {
          this.checkError.image = null;
        }
        if (!this.form.destinationType) {
          this.checkError.destinationType = 'Please Select destinationType';
        } else {
          this.checkError.destinationType = null;
        }
        if (!this.form.parent) {
          this.checkError.parent = 'Please Select parent';
        } else {
          this.checkError.parent = null;
        }
      }
    },

    validate() {
      if (!this.form.name || !this.form.name_en 
      || !this.form.parent || !this.form.destinationType 
      || this.form.parent.level > 3 || !this.form.image.id 
      || !this.form.image.url) {
        this.$swal('Mandatory field required',
         'Please fill all mandatory field', 'warning');
        return false;
      }

      return true;
    },
    validateModal() {
      if (!this.formModal.name || !this.formModal.name_en 
      || !this.formModal.parent || !this.formModal.destinationType 
      || this.formModal.parent.level > 3 || !this.formModal.image.id 
      || !this.formModal.image.url) {
        this.$swal('Mandatory field required',
         'Please fill all mandatory field', 'warning');
        return false;
      }

      return true;
    },

    submit(type) {
      if (type === 'modal') {
        const result = this.validateModal();
        if (!result) return;

        if (this.isCreateModal) {
          this.create(type);
        } else {
          this.update(type);
        }
      } else {
        const result = this.validate();
        if (!result) return;
  
        if (this.isCreate) {
          this.create();
        } else {
          this.update();
        }
      }
    },
    generateData(type) {
      /* eslint no-else-return: "error" */
      if (type === 'modal') {
        const dataModal = {
          type: this.formModal.type,
          name: this.formModal.name,
          name_en: this.formModal.name_en,
          description: this.formModal.description,
          description_en: this.formModal.description_en,
          slug: this.formModal.slug,
          region_type: this.formModal.destinationType,
          parent_id: parseInt(this.formModal.parent.id, 10),
          image: parseInt(this.formModal.image.id, 10),
        };

      return dataModal;
      } 
        const data = {
          type: this.form.type,
          name: this.form.name,
          name_en: this.form.name_en,
          description: this.form.description,
          description_en: this.form.description_en,
          slug: this.form.slug,
          region_type: this.form.destinationType,
          parent_id: parseInt(this.form.parent.id, 10),
          image: parseInt(this.form.image.id, 10),
        };

        return data;
    },

    create(type) {
      if (type === 'modal') {
        const data = this.generateData(type);

        this.axios.post('/destinations', this.stringify(data))
          .then(() => {
            this.get();
            this.setDefaultModal();
            this.$swal(
              'Succeed',
              'Create new destination succeed.',
              'success',
              1000,
            );
          })
          .catch((error) => {
            if (error.response) {
              this.$swal({
                title: 'Failed',
                text: 'Destination Name already used.',
                type: 'error',
                timer: 8000,
              });
            }
          });
      } else {
        const data = this.generateData();
  
        this.axios.post('/destinations', this.stringify(data))
          .then((res) => {
            this.get();
            const id = res.data.data.id;
            const newDestination = res.data.data;
            if (newDestination.region_type === 'province' || (newDestination.region_type === 'country' && newDestination.type === 'international')) {
              this.$swal({
                title: 'Succeed',
                text: `${newDestination.region_type === 'province' ? 'Create new destination succeed. Do you want to add new city in this province?' : 'Create new destination succeed. Do you want to add new city in this country?'}`,
                type: 'success',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                }).then((result) => {
                if (result.value) {
                  this.$router.push({
                    name: 'destination-edit',
                    params: {
                      id,
                    },
                    query: {
                      isConfirm: true,
                      type: newDestination.type,
                      parent_id: newDestination.id,
                      parent_name: newDestination.name,
                    },
                  });
                } else {
                  this.popUpCall('succeed');
                  this.$router.push({ 
                    name: 'destination-index',
                    query: {
                      type: newDestination.type,
                    },
                  });
                }
  
                if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
                  this.popUpCall('succeed');
                  this.$router.push({ 
                    name: 'destination-index',
                    query: {
                      type: newType,
                    },
                    });
                }
              });
            } else {
              this.popUpCall('succeed');
              this.$router.push({ 
                name: 'destination-index',
                query: {
                  type: newDestination.type,
                },
              });
            }
          })
          .catch((error) => {
            if (error.response) {
              this.popUpCall('error');
            }
          });
      }
    },

    update(type) {
      if (type === 'modal') {
        const data = this.generateData(type);
  
        this.axios.put(`/destinations/${this.formModal.id}`, this.stringify(data))
          .then(() => {
            this.get();
            this.setDefaultModal();
            this.popUpCall('edited');
          })
          .catch((error) => {
            if (error.response) {
              this.popUpCall('error');
            }
          });
      } else {
        const data = this.generateData();
  
        this.axios.put(`/destinations/${this.$route.params.id}`, this.stringify(data))
          .then((res) => {
            const newDestination = res.data.data;
            this.popUpCall('edited');
            this.$router.push({ 
              name: 'destination-index',
              query: {
                type: newDestination.type,
              },
            });
          })
          .catch((error) => {
            if (error.response) {
              this.popUpCall('error');
            }
          });
      }
    },

    cancel() {
      this.$router.push({ 
        name: 'destination-index',
        query: {
          type: this.$route.query.types,
        },
      });
      // this.$router.go(-1);
    },
  },

  created() {
    if (this.isEdit) {
      this.title = 'Edit Destination';
    }
    if (this.isView) {
      this.title = 'View Destination';
    }

    this.init();
  },

  mounted() {
    if (this.$route.query.isConfirm) {
      const queries = this.$route.query;
      this.modalVisible = true;
      this.isCreateModal = true;
      this.formModal.type = queries.type || 'domestic';
      this.formModal.destinationType = 'city' || null;
      this.formModal.parent = {
        id: queries.parent_id,
        label: queries.parent_name,
      };
    }
    if (this.$route.query.types) {
      this.form.type = this.$route.query.types || 'domestic';
    }
    if (this.$route.query.types === 'international') {
      this.destinationType = [
        { label: 'City', value: 'city' },
        { label: 'Country', value: 'country' },
      ];
    }
    bus.$on('close-modal', () => {
      this.show.gallery = false;
    });
  },

  destroyed() {
    bus.$off('close-modal');
  },
};
</script>

<style lang="scss" scoped>
@import '../orders/style.scss';
</style>



// WEBPACK FOOTER //
// src/components/modules/destinations/Form.vue